import storejs from 'storejs'
import request from '../lib/requests'
import { get, set } from "../lib/storage";

//暂时处理方案
// if (!storejs.get('unit-remark') && storejs.get('unit')) {
//     storejs.set('unit-remark', 1);
//     storejs.remove('unit');
//     storejs.set('unit', 'USD')
// }

let count = 0;
/**
 * 点对点汇率转换
 * @param {String} begin 比如USD
 * @param {String} after 比如HKD
 */
const getAbbreviation = function (begin, after) {
    return new Promise((resolve, reject) => {
        request.post(`v2/changerate`, {
            abbreviation: begin + ',' + after
        }).then(res => {
            resolve(res)
        }).catch(err => {
            //初次获取失败时再获取一次
            if (count === 0) {
                count++;
                getAbbreviation(begin, after).then(resp => {
                    resolve(resp)
                }).catch(() => {
                    reject()
                })
            } else {
                count = 0;
                reject(err)
            }
        })
    })
}

const priceKey = '78a5eb43deef9a7b5b9ce157b9d52ac4'
/**
 * 设置金额
 * @param {String, Number} price 金额
 */
const setPrice = price => {
    let value = btoa(encodeURIComponent(price))
    set(priceKey, value);
}

/**
 * 获取金额
 */
const getPrice = () => {
    let price = get(priceKey)
    return price ? decodeURIComponent(atob(price)) : '';
}

const rate = {
    state: {
        flight: sessionStorage.getItem('flight') || 1,
        hotel: sessionStorage.getItem('hotel') || 1,
        unit: storejs.get('unit') || 'USD',
        price: getPrice()  //缓存元价格（未经换算的价格）
    },
    mutations: {
        SET_FLIGHT: (state, value) => {
            set('flight', value)
            state.flight = value;
        },
        SET_HOTEL: (state, value) => {
            set('hotel', value)
            state.hotel = value
        },
        SET_UNIT: (state, value) => {
            storejs.set('unit', value);
            state.unit = value
        },
        SET_PRICE: (state, value) => {
            setPrice(value);
            state.price = value
        }
    },
    actions: {
        updateFlightRate({ commit }, to) {
            return new Promise((resolve, reject) => {
                getAbbreviation('HKD', to).then(({ data }) => {
                    if (data.code == 2000) {
                        commit('SET_FLIGHT', data.data.abbreviation);
                        commit('SET_UNIT', to)
                        resolve()
                    } else {
                        reject()
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        updateHotelRate({ commit }, to) {
            return new Promise((resolve, reject) => {
                getAbbreviation('USD', to).then(({ data }) => {
                    if (data.code == 2000) {
                        commit('SET_HOTEL', data.data.abbreviation);
                        commit('SET_UNIT', to)
                        resolve()
                    } else {
                        reject()
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        updateUnit({ commit }, unit) {
            return new Promise((resolve, reject) => {
                //flight、hotel
                Promise.all([getAbbreviation('HKD', unit), getAbbreviation('USD', unit)]).then(res => {
                    if (res[0].data.code == 2000 && res[1].data.code == 2000) {
                        commit('SET_FLIGHT', res[0].data.data.abbreviation)
                        commit('SET_HOTEL', res[1].data.data.abbreviation)
                        commit('SET_UNIT', unit)
                        resolve();
                    } else {
                        reject();
                    }
                }).catch(err => {
                    reject(err);
                })
            })
        },
        updatePrice({ commit }, price) {
            commit('SET_PRICE', price)
        }
    }
}

export default rate


// WEBPACK FOOTER //
// ./src/store/rate.js